import styled from 'styled-components';
import { h6Styles } from 'utils/resuable-css';

export const NotificationContainer = styled.div`
  margin: 8px 0;
  background: #f2f2f2;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 900px) {
    flex-wrap: wrap !important;
  }
  .action {
    display: flex;
    width: 78%;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }
  }
`;

export const Action = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  font-weight: normal;
  margin: 0;
  margin-right: 1em;
  width: 5em;
`;

export const Alert = styled.div`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  font-weight: normal;
  width: 22%;
  text-align: right;
  @media only screen and (max-width: 900px) {
    margin-top: 1.5em;
    width: 100%;
  }
`;

export const Date = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  font-weight: normal;
  margin: 0 1em;
`;
